import script from "./EditorContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorContainer.vue?vue&type=script&setup=true&lang=js"

import "./EditorContainer.vue?vue&type=style&index=0&id=572ea0b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-572ea0b7"]])

export default __exports__